var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-loader__container",class:{'c-loader__container--loading' : _vm.loading}},[(_vm.loading)?[_c('c-loader')]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }